import { Controller } from "@hotwired/stimulus"

const SELECT_CLASSES = "mt-1 block w-full rounded-lg border border-gray-300 bg-white px-3 py-2.5 text-base text-gray-900 shadow-sm focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/20 transition-colors sm:py-2 sm:text-sm"

export default class extends Controller {
  static targets = ["modal", "overlay", "form", "blockLabel", "usersContainer"]

  open(event) {
    event.preventDefault()
    const btn = event.currentTarget
    const { url, label, users, siblings } = btn.dataset

    this.formTarget.action = url
    this.blockLabelTarget.textContent = label

    const usersData = JSON.parse(users || "[]")
    const siblingsData = JSON.parse(siblings || "[]")
    const container = this.usersContainerTarget

    container.innerHTML = ""

    if (usersData.length > 0) {
      usersData.forEach(user => {
        const options = siblingsData.filter(s => !user.existing_block_ids.includes(s.id))
        const row = document.createElement("div")
        row.className = "flex flex-col gap-1 sm:flex-row sm:items-center sm:gap-3"

        const nameEl = document.createElement("span")
        nameEl.className = "text-sm font-medium text-gray-900 sm:w-1/3 shrink-0"
        nameEl.textContent = user.name
        row.appendChild(nameEl)

        if (options.length > 0) {
          const select = document.createElement("select")
          select.name = `replacements[${user.id}]`
          select.className = SELECT_CLASSES

          options.forEach(s => {
            const opt = document.createElement("option")
            opt.value = s.id
            opt.textContent = s.label
            select.appendChild(opt)
          })
          row.appendChild(select)
        } else {
          const hint = document.createElement("span")
          hint.className = "text-xs text-gray-400 italic"
          hint.textContent = this.element.dataset.noOptionsLabel || "—"
          row.appendChild(hint)
        }

        container.appendChild(row)
      })
      container.closest("[data-users-section]").classList.remove("hidden")
    } else {
      container.closest("[data-users-section]").classList.add("hidden")
    }

    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  closeOnOverlay(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
